module.exports = __webpack_public_path__ + "img/reset_password_dark.1f174e3c.svg";